import React from 'react';
import { graphql } from 'gatsby';
import Layout from 'src/components/layouts/default';
import * as classes from './index.module.scss';
import StructuredText from 'src/components/base/structuredText';

import BlockSignposting from 'src/components/blocks/blockSignposting';

export const query = graphql`
  query Homepage {
    datoCmsStart {
      homeTitle
      homeContactUs {
        blocks
        links
        value
      }
      homePhoneHours {
        blocks
        links
        value
      }
      homeFooter {
        blocks
        links
        value
      }
    }
  }
`;

const IndexPage = ({ data, location }) => (
  <Layout location={location} pageTitle={data.datoCmsStart.homeTitle}>
    <div className={classes.body}>
      <div className={classes.ctaTitle}>Ready to enroll?</div>
      <BlockSignposting theme="light" />
      <div className={classes.cta}>
        <a href="/enroll" className={'button ' + classes.button}>
          Get started
        </a>
      </div>
      <div className={classes.secondaryCta}>
        <StructuredText data={data.datoCmsStart.homeContactUs} />
        <StructuredText data={data.datoCmsStart.homePhoneHours} />
      </div>
      <footer className={classes.footer}>
        <StructuredText data={data.datoCmsStart.homeFooter} />
      </footer>
    </div>
  </Layout>
);

export default IndexPage;
